import { HttpTypes } from '@medusajs/types'
import { useProductPrice } from '@onclicks/sharedmedusa/hooks/useProductPrice'
import { cn } from '@/utilities/ui'
import { quicksand } from '@/utilities/fontImport'
import { formatPrice } from '@/utilities/formatPrice'

export default function CardPrice({
  product,
  variant,
}: {
  product: HttpTypes.StoreProduct
  variant?: HttpTypes.StoreProductVariant
}) {
  const { hasPriceData, displayPrice, currency, hasDiscount, originalPrice, discountPercent } =
    useProductPrice({ product, variant })

  if (!hasPriceData || displayPrice == null) {
    return <div className="block w-24 h-6 bg-gray-100 animate-pulse" />
  }

  return (
    <div className={cn('flex flex-1 flex-col justify-end pb-1', quicksand.className)}>
      {hasDiscount ? (
        <>
          <span className="inline-block rounded-md w-fit bg-light-pink border border-light-red px-2 py-1 mb-1 text-xs font-semibold text-light-red">
            -{discountPercent}%
          </span>
          <div className="flex items-baseline gap-2">
            <span className="line-through text-xl lg:text-2xl">
              {formatPrice(originalPrice as number, currency)}
            </span>
            <span className="text-flash-pink text-xl lg:text-2xl">
              {formatPrice(displayPrice, currency)}
            </span>
          </div>
        </>
      ) : (
        <span className="text-xl lg:text-2xl">{formatPrice(displayPrice, currency)}</span>
      )}
    </div>
  )
}
